module.exports = __webpack_public_path__ + "img/ueslogo.e06a4b76.png";